import AbstractProvidedClass from "./AbstractProvidedClass";

export default class HoverSet extends AbstractProvidedClass {
    hovered = [];

    add(element) {
        if (Array.isArray(element)) {
            element.map(e => this.add(e));
            return;
        }
        element.hover();
        this.hovered.push(element);
    }

    set(elements) {
        this.reset();
        if (elements) {
            this.add(elements);
        }
    }

    reset() {
        this.hovered.map(e => e.unhover());
        this.hovered = [];
    }

    remove(element) {
        this.hovered = this.hovered.filter(e => {
            if (e == element) {
                e.unhover();
                return false;
            }
            return true;
        });
    }
}
